import { render, staticRenderFns } from "./NotFoundLayout.vue?vue&type=template&id=05bdd918&"
import script from "./NotFoundLayout.vue?vue&type=script&lang=js&"
export * from "./NotFoundLayout.vue?vue&type=script&lang=js&"
import style0 from "./NotFoundLayout.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports